import { render, staticRenderFns } from "./treadsList.vue?vue&type=template&id=ab052f38"
import script from "./treadsList.vue?vue&type=script&lang=js"
export * from "./treadsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports